import { AuthEndpoints, createAuthUrl, getCurrentHost } from "./endpointUtils";

export function logout(redirectTo?: string) {
  let redirectUrl = redirectTo || "/";
  if (redirectUrl.startsWith("/")) {
    redirectUrl = getCurrentHost() + redirectUrl;
  }
  window.location.assign(createAuthUrl(getCurrentHost(), AuthEndpoints.SIGN_OUT, redirectUrl));
}
